export const LOGIN_RETURN_URL_KEY = 'LOGIN_RETURN_URL_KEY';
/** App 다운받고 처음 로그인(SNS) 시도 했지만 실패했는지 여부 저장 */
export const LOGIN_APP_FIRST_KEY = 'LOGIN_APP_FIRST_KEY';

/** 서비스 쿠션 페이지: 해당 페이지를 제외하고 내차 팔기 홈으로 이동하는 내부 정책이 있음 */
export const CUSHION_PAGE_URLS = [
	'apply/save-garage', // 내차고 차량 저장
	'cars/detail', // 차량상세
	'clPoliceNotify', // 허위신고
	'home-service/apply-intro', // 홈서비스
	'meetgo/reservation/date', // 믿고 예약
	'meetgo/walk-in/intro', // 믿고 방문
	'cars/report/accident', // 보험 이력 정보 노출
	'gateway/redirect-handler', // 내 차량 전체보기
	'self-register', // 직거래 안내
	'event/lucky-draw', // 럭키드로우 이벤트
];

export const JOIN_ERROR_CODE = {
	DUPLICATED_PHONE_NUMBER: '30025',
};

export const JOIN_ERROR_MESSAGE = {
	[JOIN_ERROR_CODE.DUPLICATED_PHONE_NUMBER]:
		'동일한 휴대전화번호로 당일 가입 이력이 확인되어 추가 회원가입이 제한됩니다. 도움이 필요하신 경우 고객센터(1599-5455)로 연락 부탁 드립니다.',
	DEFAULT: '회원가입에 실패했습니다.',
};

export const LOGIN_ERROR_CODE = {
	BLACKLIST_MEMBER: '30004',
};

export const LOGIN_ERROR_MESSAGE = {
	DEFAULT: '회원가입 후 로그인에 실패했습니다. 로그인 후 사용가능합니다.',
};
